exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".identify .infoWindow .titlePanel{\r\n    width: 100%;\r\n    text-align: center;\r\n    background-color: #31718d;\r\n    height: 40px;\r\n    line-height: 40px;\r\n}\r\n.identify .infoWindow h3 {\r\n    margin: 0 auto;\r\n    color: white;\r\n}", ""]);

// exports
